export const SalesEndSoon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 16 16" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.33301 4.00033V2.66699H12.6663V4.00033L8.99967 8.00033L12.6663 12.0003V13.3337H3.33301V12.0003L6.99967 8.00033L3.33301 4.00033ZM6.93996 5.4687C7.58731 5.87365 8.41204 5.87365 9.05938 5.4687L10.0998 4.33366H5.89951L6.93996 5.4687ZM6.00402 11.553L7.99967 9.3759L9.99533 11.553L9.22104 11.0368C8.85935 10.7957 8.43437 10.667 7.99967 10.667C7.56497 10.667 7.14 10.7957 6.77831 11.0368L6.00402 11.553Z"
        fill="#261B36"
      />
    </svg>
  );
};
